<template>
    <v-app>
        <v-img
                contain
                max-height="200"
                class="pink--text"
                :src="require('../assets/virtuaalijono.svg')"
        ></v-img>
        <div class="text-center">
            <v-card-title class="layout align-center fill-height margin-block">
                <h1>Lisätietoja</h1>
            </v-card-title>
            <v-card-text fill-height class="narrow-content">
                <p>
                    Tämä on Särkänniemen virtuaalijonon pilotti, jossa
                    testaamme virtuaalisen jonottamisen toimivuutta ja
                    Särkänniemen asiakkaiden suhtautumista siihen.
                </p>
                <p>
                    Pilottiin osallistutaan kertakäyttöisellä linkillä, jonka voi
                    saada pilotista vastaavalta henkilökunnalta Särkänniemen
                    alueella.
                </p>
                <p>Virtuaalijonon hyödyntämisen jälkeen pyydämme teitä
                    osallistumaan virtuaalijonoa koskevaan
                    palautteenantoon Tukkifoton luona, Tukkijoen uloskäynnin läheisyydessä.
                    Palautteeannosta palkkiona on Särkänniemen vapaalippu.
                </p>
                <p>Kaikki osana pilottia toteutetut järjestelmät ja toimintatavat
                    ovat kehitysvaiheessa ja tulevat muuttumaan pilotista
                    saadun palautteen mukaan.
                </p>
                <p>Särkänniemi toteuttaa pilotin yhteistyössä Futuricen kanssa.
                </p>
                <p>Pilotin kontaktihenkilöinä toimivat:</p>
                <p>
                    <b>Kirsi Aarresuo</b><br />
                    0207130341
                </p>
                <p>
                    <b>Miikka Nenonen</b><br />
                    0207130353
                </p>
                <v-btn
                        text color="#00B0EE"
                        width="100%"
                        class="margin-block"
                        @click="goBack()">
                    Takaisin
                </v-btn>
            </v-card-text>

        </div>
    </v-app>
</template>

<script>
  import "es6-promise/auto";

  export default {
    name: "Info",
    components: {},
    methods: {
      goBack: function() {
        this.$router.go(-1);
      }
    }
  };
</script>

<style scoped>
    p {
        font-size: 16px;
    }
</style>
